import { IChildrenProps } from '@maxpreps/shared/models/utilTypes';
import THEME from '@maxpreps/shared/styles/colors';
import Font from '@maxpreps/shared/styles/font';
import StyledText from '@maxpreps/shared/ui/Text/StyledText';
import React from 'react';
import styled from 'styled-components';

const StyledRecordSummaryBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:first-child {
    border-right: 1px solid ${THEME.general.border};
  }
`;

interface IRecordSummaryBoxProps extends IChildrenProps {
  type: string;
  record: string;
}

const RecordSummaryBox: React.FC<IRecordSummaryBoxProps> = ({
  type,
  record,
  children
}) => (
  <StyledRecordSummaryBox>
    <StyledText
      className={Font.f11_bold_tall_upper}
      $color={THEME.text.tertiary}
    >
      {type}
    </StyledText>

    <StyledText className={Font.f18_bold} $fontSize="20px">
      {record}
    </StyledText>
    {children}
  </StyledRecordSummaryBox>
);

export default RecordSummaryBox;
